import React from 'react';

import { Box, Text, Center } from '@chakra-ui/react';

import WithAnimation from '@components/Common/WithAnimation';
import Image from '@components/Common/LazyImage';
import ImagesFade from '@components/Common/ImagesFade';

import { SPH_LOGO } from '@/constants/sph';

/**
 * function to render ayat section with Ayat content
 * @returns {JSX.Element}
 */
function AyatSection() {
  return (
    <Box>
      <ImagesFade />
      <Box padding="42px 32px 42px 32px " bgColor="bgPrimary" marginTop="-40px">
        <Box p="24px 32px" bg="bgAlternative" borderRadius="16px">
          <Center>
            <Image src={SPH_LOGO} height="90px" />
          </Center>
          <WithAnimation>
            <Text textAlign="center" color="secondaryColorText" paddingTop="16px">
              <i>True Knowledge. Faith in Christ. Godly Character.</i>
              <br /> <br />
              Dear parents, <br /> <br />
              We are eager to welcome you to our school community as we enter our 31<sup>
                st
              </sup>{' '}
              year of loving students and equipping them for lives of leadership, service, and
              impact. <br /> <br />
              We welcome you to join us at our new family orientation.<br />
            </Text>
          </WithAnimation>
          <WithAnimation>
            <Text
              fontSize="sm"
              fontWeight="bold"
              align="center"
              color="secondaryColorText"
              marginTop="8px"
            >
              Matthew Mann – Executive Director
            </Text>
          </WithAnimation>
        </Box>
      </Box>
    </Box>
  );
}

export default React.memo(AyatSection);
